export enum ElementSizeTokensEnum {
  SMALL = "sm",
  DEFAULT = "default",
  LARGE = "lg",
  XLARGE = "xl"
}
